<oph-icon [name]="data.type | snackbarIconName" [size]="27"></oph-icon>
<div class="message-container">
  <span>{{ data.type === 'error' ? 'Error: ' : '' }} {{ data.message || '' }}</span>
</div>
<oph-x-button (buttonClick)="snackBarRef.dismissWithAction()"></oph-x-button>
